import {
  Box,
  List,
  ListItem,
  ListItemText,
  Menu,
  MenuItem
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import ExpandMoreTwoToneIcon from '@mui/icons-material/ExpandMoreTwoTone';
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import { setGlobalState, useGlobalState } from 'src/state/globalstate';
import { AmacUrl } from 'src/common/routes';

const ListWrapper = styled(Box)(
  ({ theme }) => `
        .MuiTouchRipple-root {
            display: none;
        }
        
        .MuiListItem-root {
            transition: ${theme.transitions.create(['color', 'fill'])};
            
            &.MuiListItem-indicators {
                padding: ${theme.spacing(1, 2)};
            
                .MuiListItemText-root {
                    .MuiTypography-root {
                        &:before {
                            height: 4px;
                            width: 22px;
                            opacity: 0;
                            visibility: hidden;
                            display: block;
                            position: absolute;
                            bottom: -10px;
                            transition: all .2s;
                            border-radius: ${theme.general.borderRadiusLg};
                            content: "";
                            background: ${theme.colors.primary.main};
                        }
                    }
                }

                &.active,
                &:active,
                &:hover {
                
                    background: transparent;
                
                    .MuiListItemText-root {
                        .MuiTypography-root {
                            &:before {
                                opacity: 1;
                                visibility: visible;
                                bottom: 0px;
                            }
                        }
                    }
                }
            }
        }
`
);

function HeaderMenu() {
  const ref = useRef<any>(null);
  let navigate = useNavigate();
  const [isOpen, setOpen] = useState<boolean>(false);
  const [toggle, settoggle] = useState(true);
  const toggleStatus = useGlobalState('toggleStatus');
  const state = localStorage.getItem('Access_State');
  const userRole = localStorage.getItem('Access_Urm');
  const Access_State = localStorage.getItem('Access_State');
  const [selectedState, setSelectedState] = useState<string>(Access_State);

  const handleOpen = (): void => {
    setOpen(true);
  };

  const handleClose = (): void => {
    setOpen(false);
  };

  useEffect(() => {
    setSelectedState(state);
  }, []);

  const toggleSidebar = async () => {
    if (toggle) {
      console.log('False called');
      setGlobalState('toggleStatus', false);
      settoggle(false);
    } else if (!toggle) {
      console.log('True called');
      setGlobalState('toggleStatus', true);
      settoggle(true);
    }
  };

  const changeState = (event: React.ChangeEvent<HTMLSelectElement>) => {
    setSelectedState(event.target.value);

    const urlPath = window.location.pathname; // e.g., "/wa/admin"
    const newState = '/' + event.target.value;
    // Regular expression to match the first part of the path after the first slash
    const updatedPath = urlPath.replace(/^\/[^\/]+/, newState); // Replace first segment with 'ca'
    localStorage.setItem('Access_State', String(event.target.value));
    const updatedUrl = window.location.origin + newState + AmacUrl.Dashboard; // Get the full updated URL
    console.log('updatedUrl === ', updatedUrl);
    // Navigate to the updated URL
    window.location.href = updatedUrl;
  };

  return (
    <>
      <ListWrapper>
        <List disablePadding component={Box} display="flex">
          {userRole == '1' ? (
            <>
              <select
                value={selectedState}
                onChange={changeState}
                style={{
                  background: '#092b71',
                  border: '1px solid #666',
                  color: '#fff',
                  // fontSize: '12px',
                  fontWeight: '600',
                  padding: '5px 8px',
                  borderRadius: '4px',
                  marginLeft: '10px',
                  marginTop: '5px'
                }}
              >
                <option value="wa">Washington</option>
                <option value="ca">California</option>
              </select>
            </>
          ) : (
            ''
          )}
          {/* <ListItem
            classes={{ root: 'MuiListItem-indicators' }}
            button
            component={NavLink}
            to="/components/buttons"
          >
            <ListItemText
              primaryTypographyProps={{ noWrap: true }}
              primary="Buttons"
            />
          </ListItem>
          <ListItem
            classes={{ root: 'MuiListItem-indicators' }}
            button
            component={NavLink}
            to="/components/forms"
          >
            <ListItemText
              primaryTypographyProps={{ noWrap: true }}
              primary="Forms"
            />
          </ListItem>
          <ListItem
            classes={{ root: 'MuiListItem-indicators' }}
            button
            ref={ref}
            onClick={handleOpen}
          >
            <ListItemText
              primaryTypographyProps={{ noWrap: true }}
              primary={
                <Box display="flex" alignItems="center">
                  Others
                  <Box display="flex" alignItems="center" pl={0.3}>
                    <ExpandMoreTwoToneIcon fontSize="small" />
                  </Box>
                </Box>
              }
            />
          </ListItem> */}
        </List>
      </ListWrapper>
      {/* <Menu anchorEl={ref.current} onClose={handleClose} open={isOpen}>
        <MenuItem sx={{ px: 3 }} component={NavLink} to="/overview">
          Overview
        </MenuItem>
        <MenuItem sx={{ px: 3 }} component={NavLink} to="/components/tabs">
          Tabs
        </MenuItem>
        <MenuItem sx={{ px: 3 }} component={NavLink} to="/components/cards">
          Cards
        </MenuItem>
        <MenuItem sx={{ px: 3 }} component={NavLink} to="/components/modals">
          Modals
        </MenuItem>
      </Menu> */}
    </>
  );
}

export default HeaderMenu;
